import { core } from './WasmCache'

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function getSupportedProvinceId(province) {
  return core.supportedProvinces().find((x) => x.code === province)?.id
}

export function getSignUpCategoryId(category) {
  return core.signUpCategories().find((x) => x.code === category)?.id
}
